/** @jsx jsx */
import { jsx } from '@emotion/core';
import CachingEmoji from './CachingEmoji';
import { emojiName, emojiShortName, preview, previewImg, previewText } from './styles';
export const EmojiPreviewComponent = ({
  emoji
}) => {
  return jsx("div", {
    css: preview
  }, jsx("span", {
    css: previewImg
  }, jsx(CachingEmoji, {
    key: emoji.id || emoji.shortName,
    emoji: emoji
  })), jsx("div", {
    css: previewText
  }, emoji.name && jsx("div", {
    css: emojiName
  }, emoji.name), jsx("div", {
    css: emojiShortName
  }, emoji.shortName)));
};